import React from "react"
import "./index.css"

export const ModalTitle = (props: any) => {
    const { title } = props
    return (
        <div className="modal-title">
            <h3>{title}</h3>
        </div>
    )
}

export const ModalContent = (props: any) => {
    const { Content } = props
    return (
        <div className="modal-content">
            {React.isValidElement(Content) ? Content : <Content />}
        </div>
    )
}

export const ModalButtoms = (props: any) => {
    const { onCancel, onSubmit, showConfirm } = props
    return (
        <div className="modal-buttons">
            <input
                className="button_register"
                type="button"
                value="Cerrar"
                onClick={onCancel}
            />
            {showConfirm && (
                <input
                    className="button-clear_fields"
                    type="button"
                    value="Confirmar"
                    onClick={onSubmit}
                />
            )}


        </div>
    )
}

const Modal = (props: any) => {
    const {
        isOpen = false,
        title = '',
        Content = <></>,
        onCancel = (e: any) => { },
        onSubmit = (e: any) => { },
        renderBlurBackground = true,
        center = true,
        extraClasses = "",
        showConfirm = true
    } = props

    return isOpen ? (<>
        {renderBlurBackground && (<div className="modal-background" onClick={onCancel}></div>)}

        <div className={`modal ${extraClasses} ${center ? 'center' : ''}`}>
            <ModalTitle title={title} />
            <ModalContent Content={Content} />
            <ModalButtoms onSubmit={onSubmit} onCancel={onCancel} showConfirm={showConfirm} />
        </div>
    </>) : null
}

export default Modal
